import {Fragment} from "react";
import PersonForm from "../../../../component/PersonForm/PersonForm";
import StaticLoginForm from "../../../../component/StaticLoginForm/StaticLoginForm";
import AddressForm from "../../../../component/AddressForm/AddressForm";
import Select from "../../../../component/Select/Select";
import ExceptionGoodForm from "../../../../component/ExceptionGoodForm/ExceptionGoodForm";

const ManagerForm = ({manager , onChange}) => {

    const accessibilityOptions = [
        {
            label : "مالک" ,
            value : "OWNER" ,
        },{
            label : "مدیر" ,
            value : "MANAGER" ,
        }
    ];

    const changeManager = (key, value) => {
        const newManager = {...manager, [key]: value}
        if (key == "accessibility" && value == "OWNER"){
            newManager.exceptionGood = {
                includeProduct: [],
                excludeProduct: [],
                includeCategory: [],
                excludeCategory: [],
                includeBrand: [],
                excludeBrand: [],
            }
        }
        onChange(newManager);
    }

    return (
        <Fragment>
            <PersonForm person={manager.person} onChange={(value) => {
                const newPerson = {...manager.person, ...value};
                changeManager("person", newPerson);
            }}/>





            <div className="col-md-6">
                <Select label={"سطح دسترسی"} options={accessibilityOptions} value={manager.accessibility} onChange={(value) => {
                    changeManager("accessibility", value);
                }}  />
            </div>

            {
                manager.accessibility == "MANAGER" && <ExceptionGoodForm exceptionGood={manager.exceptionGood} onChange={(value) => {
                    changeManager("exceptionGood", value);
                }} />
            }
        </Fragment>
    );
}

export default ManagerForm;